var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: ".8rem",
    height: ".8rem",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "m11.461 4.515-6.55 6.556-3.892.002L1 7.159 7.706.453a1.604 1.604 0 0 1 2.235 0l1.676 1.677c.605.604.449 1.78-.156 2.385zM2.112 9.968l1.682-.015-1.676-1.676-.006 1.691zm7.829-7.28-.559-.558a.802.802 0 0 0-1.118 0L3.235 7.16l1.677 1.676 5.029-5.03a.802.802 0 0 0 0-1.117zM0 14h16v2H0z"
  }))));
};
export default SvgEdit;